import {getId} from 'apis/model/base'
import React, {useContext} from 'react'
import CodiContext from './CodiContext'
import {BrosCodiDocuments} from "../../Document/components/Codi/CodiDocumentSource";

const CodiBrosCodi = ({style, className, ...props}) => {
  const {item} = useContext(CodiContext)
  return (
    <BrosCodiDocuments
      style={style}
      className={className}
      codi_id={getId(item)}
      codi_document_type_id={item?.document_type?.id}
      {...props}
    />
  )
}

export default CodiBrosCodi
